import { lazy } from 'react';

// Config
import { showVoucherUnderspendWarning } from './VoucherUnderspendWarningModal.constants';

// Components
import withSuspense, { lazyRetry } from '@components/suspense';

const LazyComponent = lazy(() =>
  lazyRetry(() => import(/* webpackChunkName: "voucherUnderspendWarningModal" */ './VoucherUnderspendWarningModal')),
);

const LazyComponentWithSuspense = withSuspense<{}>(LazyComponent, 'VoucherUnderspendWarningModal');

// Exports
export default LazyComponentWithSuspense;
export { LazyComponent as VoucherUnderspendWarningModal, showVoucherUnderspendWarning };
